<template>
  <v-layout
    id="form"
    row
    wrap
    justify-center>
    <v-flex
      class="contact-form-flex"
      xs12
      sm6
      md6>
      <v-form
        v-if="!bSucces"
        ref="contact-form"
        v-model="bValidated"
        lazy-validation>
        <v-layout
          row
          wrap>
          <v-flex
            xs12
            sm12
            md12>
            <p
              class="contact-form-title">
              Agenda tu cita
            </p>
            <p
              class="contact-form-subtitle">
              Nuestro equipo se pondra en contacto contigo para confirmar tu cita. 
            </p>
          </v-flex>
          <v-flex
            xs12
            sm6
            md6>
            <p
              class="text-field-label-contact">
              <b>Nombre(s)</b> <i> (Names)</i>
            </p>
            <v-text-field
              color="#306BE6"
              :class="$vuetify.breakpoint.smAndDown ? 'contact-form-text-field':'contact-form-text-field max-95'"
              v-model="sName"
              :rules="requiredRule"
              placeholder="Nombre(s)"
              clearable
              required
            ></v-text-field>
          </v-flex>
          <v-flex
            xs12
            sm6
            md6>
            <p
              class="text-field-label-contact">
              <b>Apellido</b> <i> (Last Name)</i>
            </p>
            <v-text-field
              color="#306BE6"
              class="contact-form-text-field"
              v-model="sLastName"
              :rules="requiredRule"
              placeholder="Nombre(s)"
              clearable
              required
            ></v-text-field>
          </v-flex>
          <v-flex
            xs12
            sm12
            md6>
            <p
              class="text-field-label-contact">
              <b>Correo Electrónico</b> <i> (Email Address)</i>
            </p>
            <v-text-field
              color="#306BE6"
              :class="$vuetify.breakpoint.smAndDown ? 'contact-form-text-field':'contact-form-text-field max-95'"
              v-model="sEmail"
              :rules="emailRules"
              placeholder="Correo Electrónico"
              clearable
              required
            ></v-text-field>
          </v-flex>
          <v-flex
            xs12
            sm12
            md6>
            <p
              class="text-field-label-contact">
              <b>Consultorio</b> <i> (Location)</i> (San Jose, Ángeles)
            </p>
            <v-text-field
              color="#306BE6"
              class="contact-form-text-field"
              v-model="sLocation"
              :rules="requiredRule"
              placeholder="Consultorio"
              clearable
              required
            ></v-text-field>
          </v-flex>
          <v-flex
            xs12
            sm12
            md12>
            <p
              class="text-field-label-contact">
              <b>Motivo</b> <i> (Reason)</i> 
            </p>
            <v-textarea
              rows="3"
              color="#306BE6"
              class="contact-form-text-field"
              v-model="sMotive"
              :rules="requiredRule"
              placeholder="Motivo"
              clearable
              required
            ></v-textarea>
          </v-flex>
          <v-flex
            style="margin-top: 20px"
            row
            xs12
            sm12
            md12>
            <v-spacer></v-spacer>
            <v-btn
              @click="sendForm"
              :loading="bLoading"
              :disabled="!bFieldsFilled || bLoading"
              style="border-radius: 10px"
              depressed
              :width="$vuetify.breakpoint.smAndUp ? '24%':'50%'"
              height="42px"
              color="#306BE6">
              <p
                class="contact-form-send">
                Agendar Cita
              </p>
            </v-btn>
            <v-spacer
              v-if="$vuetify.breakpoint.smAndDown"
            ></v-spacer>
          </v-flex>
        </v-layout>
      </v-form>
      <div
        v-else-if="bSucces">
        <v-layout
          row
          wrap>
          <v-flex
            xs12
            sm12
            md12>
            <p
              class="contact-form-title">
              Tu solicitud ha sido enviada.
            </p>
            <p
              class="contact-form-subtitle">
              Nos comunicaremos contigo a la breevedad.
            </p>
          </v-flex>
        </v-layout>
      </div>
    </v-flex>
    <v-flex        
      :style="$vuetify.breakpoint.smAndUp ? '':'padding: 24px !important'"
      class="contact-form-flex"
      xs12
      sm6
      md6>
      <iframe 
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1338.7375309695574!2d-100.32113274720832!3d25.645384474210527!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8662be4147d87349%3A0xb3a3ad652e58e9e5!2sHospital%20Angeles%20Valle%20Oriente!5e0!3m2!1sen!2smx!4v1633388492352!5m2!1sen!2smx" 
        width="100%" 
        :height="$vuetify.breakpoint.smAndUp ? '100%':'500px'"
        style="border:0;" 
        allowfullscreen="" 
        loading="lazy">
      </iframe>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  data: () => ({
    // form values
    bValidated: false,
    requiredRule: [
      v => !!v || 'El campo es requerido.',
      // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
    ],
    sName: '',
    sLastName: '',
    sEmail: '',
    sMotive: '',
    sLocation: '',
    emailRules: [
      v => !!v || 'El correo electrónico es requerido',
      v => /.+@.+\..+/.test(v) || 'El correo electrónico debe de ser válido.',
    ],
    dDate: null,
    bLoading: false,
    bSucces: false
  }),
  computed: {
    bFieldsFilled () {
      return this.sName !== "" && this.sLastName !== "" && this.sEmail !== "" && this.sMotive !== "" && this.sLocation !== "" 
    }
  },
  methods: {
    setAlert (text, type) {
      this.$store.commit('toggleAlert', {
        sText: text,
        sAlertType: type // error , success
      })
    },
    sendForm () {
      this.bLoading = true
      var self = this
      var templateParams = {
        name: this.sName, 
        last_name: this.sLastName, 
        email: this.sEmail, 
        location: this.sLocation, 
        motive: this.sMotive
      };
      emailjs.send('service_wma1kme','template_iw93b97', templateParams)
        .then(function(response) {
          self.bLoading = false
          self.bSucces = true
          self.setAlert('Se envió tu solicitud correctamente', 'success')
        }, function(err) {
          self.bLoading = false
          self.bSucces = false
          self.setAlert('Hubo un error enviando tu solicitud, porfavor intenta más tarde', 'error')
        });
    }
  }
}
</script>
<style 
  scoped>
  .max-95 {
    max-width: 95%;
  }
  .contact-form-send {
    font-family: 'Raleway', sans-serif;
    color: white;
    font-size: 11px;
    text-transform: none !important;
  }
  .contact-form-text-field ::placeholder {
    padding-left: 10px;
    font-family: 'Raleway', sans-serif;
    text-align: left;
    font-weight: 500;
    font-size: 13px;
  }
  .text-field-label-contact {
    font-family: 'Raleway', sans-serif;
    text-align: left;
    font-weight: 500;
    font-size: 13px;
    margin-bottom: -18px !important;
    margin-top: 18px;
  }
  .contact-form-title {
    font-family: 'Raleway', sans-serif;
    text-align: left;
    font-weight: 800;
    font-size: 35px;
  }
  .contact-form-subtitle {
    margin-bottom: 25px;
    font-family: 'Raleway', sans-serif;
    text-align: left;
    font-weight: 500;
    font-size: 18px;
    margin-top: 10px;
  }
  #form {
    padding-top: 80px;
    background-color: white;
    position: relative;
    z-index: 2;
    height: auto; 
  }
  .contact-form-flex {
    padding: 90px;
  }
</style>